<template>
  <section class="section section-quote" v-if="quote && quote.text">
    <div class="container container-small">
      <Blockquote :visible="visible || mobile" :quote="quote" />
    </div>
  </section>
</template>
<script>
import Blockquote from '@/components/Blockquote.vue'

export default {
  name: 'QuoteSection',
  props: ['quote', 'visible', 'mobile'],
  components: {
    Blockquote
  }
}
</script>

<style scoped lang="scss">
.section-quote {
  padding: $gap-xl 0;

  @include screen ('md') {
    .container-small {
      margin: $gap-lg auto;
      width: 88%;
    }
  } // END @include screen ('md');
} // END .section-quote;
</style>
